// extracted by mini-css-extract-plugin
module.exports = {"shareIconButton":"components-base-Button-Icons-ShareIconButton-ShareIconButton__shareIconButton--c-3AO"};